export default typeof SharedArrayBuffer !== "undefined";